module.exports = __webpack_public_path__ + "img/fk.a5e298cc.svg";